import { Moment } from 'moment';

import { ParamsAdapter } from '@ng-gems/api';

export class NotificationGetParams extends ParamsAdapter {
  /**
   * @param lastSeenNotificationId Id of the last loaded notification
   * @param maxCreationDate Creation date of the last loaded notification
   */
  constructor(
    private lastSeenNotificationId?: number,
    private maxCreationDate?: Moment,
  ) {
    super();
  }

  getParams(): unknown {
    const apiParams = {};
    apiParams['max_creation_date'] = this.maxCreationDate;
    if (this.lastSeenNotificationId) {
      apiParams['last_seen_id'] = this.lastSeenNotificationId;
    }

    return apiParams;
  }
}
